/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PayAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function PayAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentSetup/Pay/PayAction",
  disabled
  
}) {
let constantData = 'Pay '
let payersActivetabDataDownpaymentValueData = fromData.useDataFormat({ viewPath,
context: 'payers',
path: 'activeTab.data.downpayment',
format: fromFormat.numberMoney,
})
let aggregateData = fromAggregate.joinNoSpace(constantData, payersActivetabDataDownpaymentValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  disabled
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 disabled={disabled}
 onClick={onClick}
 type="primary"
 block={true}
 data="'Pay '"
 data="payers.activeTab.data.downpayment"
 format="/Data/format.js numberMoney"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}